import styled from 'styled-components';
import { ActionTableBodyItem, TableBodyItem } from '../../Table.styles';

export const NameCell = styled(TableBodyItem)`
  gap: 0.8rem;
  font-weight: ${({ $unseen }) => ($unseen ? 600 : 300)};
  color: ${({ $unseen }) => ($unseen ? '#0B3A5F' : 'inherit')};
`;

export const ValueCell = styled(TableBodyItem)`
  font-weight: ${({ $unseen }) => ($unseen ? 500 : 300)};
  color: ${({ $unseen }) => ($unseen ? '#0B3A5F' : 'inherit')};
`;

export const DetailsCell = styled(ActionTableBodyItem)`
  width: 10rem;
`;

export const UnseenDot = styled.span`
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background: #1672ba;
  box-shadow: 0 0 0 2px rgba(22, 114, 186, 0.18);
  flex-shrink: 0;
`;

export const DotPlaceholder = styled.span`
  width: 0.8rem;
  height: 0.8rem;
  flex-shrink: 0;
`;

export const DetailsButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  border: 1px solid #d2d6db;
  background: #fff;
  color: #1672ba;
  font-size: 1.3rem;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #f9fafb;
  }
`;
